//ANGULAR
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
//COMPONENTS
import { MessageBoxComponent } from './components/message-box/message-box.component';
//3RD PARTY
import {InputTextModule} from 'primeng/inputtext';
//SERVICES
import { MessageBoxService } from './services/message-box.service';
import { AuthGuardService } from './services/auth-guard.service';
import { RoleGuardService } from './services/role-guard.service';
//INTERCEPTORS
import { TokenInterceptor } from './httpInterceptors/token.interceptor';
import { LoginService } from './services/login.service';
import { LocaleService } from './services/locale.service';
import { TranslateService } from './services/translate.service';
import { EpayService } from './services/epay.service';
import { LoggerService } from './services/logger.service';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    InputTextModule,
    BrowserModule,
    BrowserAnimationsModule
    
  ],
  declarations: [
    MessageBoxComponent
  ],
  providers: [
    {
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true
    },
    MessageBoxService,
    AuthGuardService,
    RoleGuardService,
    LoginService,
    LocaleService,
    TranslateService,
    EpayService,
    LoggerService
  ],
  exports: [
    RouterModule,
    MessageBoxComponent
  ]
})
export class CoreModule { }
